// removed by extract-text-webpack-plugin
module.exports = {"yx_popconfirm":"yx_popconfirm"};


//////////////////
// WEBPACK FOOTER
// ./src/yx-widget/component/YxPopconfirm/index.less
// module id = ./src/yx-widget/component/YxPopconfirm/index.less
// module chunks = 43